import { createRouter, createMemoryHistory} from 'vue-router'
import MainPage from '../../components/MainPage'
import PrintView from '../../components/PrintView'
import ProjectReports from '../../components/ProjectReports'
import LoginView from '../../components/LoginView'

const routes = [
    {path: '/', component: MainPage},
    {path: '/login', component: LoginView},
    {path: '/report/:id', component: ProjectReports},
    {path: '/print/:id', component: PrintView}
]
const router = createRouter({
    history: createMemoryHistory(),
    routes,
})

export default router